export const articleHeader = '#eceeef'
export const background = '#8C53A0'
export const componentBorder = '#ced4da'
export const tableZebra = '#f7f7f7'
